/**
 * Eventos do calendário do setor no formato do calendário compartilhado
 * (components/Calendar: {id, date, title, subtitle, groupLabel, tone,
 * previsao, payload}).
 *
 * Duas bases, como no calendário de Solicitações:
 * - "limite": o prazo que vale (ambiente: prazo efetivo; tarefa: data limite);
 * - "prevista": quando o gestor espera terminar (desenhado tracejado).
 * Atrasado é `danger`; o resto leva o tom do status (cor só comunica estado).
 */
import { toDate } from "../../../utils/status";
import {
  ROTULO_STATUS_AMBIENTE,
  ROTULO_STATUS_TAREFA,
  TOM_STATUS_AMBIENTE,
  TOM_STATUS_TAREFA,
  tarefaAtrasada,
} from "./vocabulario";

export const BASES_CALENDARIO = Object.freeze([
  { valor: "limite", rotulo: "Prazo" },
  { valor: "prevista", rotulo: "Previsão" },
]);

function eventoDoAmbiente(demanda, base) {
  const date = base === "prevista" ? demanda.prevista : demanda.prazoEfetivo;
  if (!date) return null;
  return {
    id: `ambiente:${demanda.chaveLinha || demanda.chave}`,
    date,
    title: demanda.rotulo || demanda.ambiente,
    subtitle: ROTULO_STATUS_AMBIENTE[demanda.statusApp] || "",
    groupLabel: demanda.cliente || "Sem cliente",
    tone: demanda.atrasada ? "danger" : TOM_STATUS_AMBIENTE[demanda.statusApp] || "neutral",
    previsao: base === "prevista",
    payload: { tipo: "ambiente", demanda },
  };
}

function eventoDaTarefa(tarefa, base, hoje) {
  const date = toDate(base === "prevista" ? tarefa.data_prevista : tarefa.data_limite);
  if (!date) return null;
  return {
    id: `tarefa:${tarefa.id}`,
    date,
    title: [tarefa.codigo, tarefa.titulo].filter(Boolean).join(" · "),
    subtitle: ROTULO_STATUS_TAREFA[tarefa.status] || "",
    groupLabel: tarefa.ambiente_rotulo || "Sem ambiente",
    tone: tarefaAtrasada(tarefa, hoje) ? "danger" : TOM_STATUS_TAREFA[tarefa.status] || "neutral",
    previsao: base === "prevista",
    payload: { tipo: "tarefa", tarefa },
  };
}

/**
 * Eventos de ambientes (combinados) e tarefas numa lista só. Sem data na
 * base escolhida, fica de fora — `semData` diz quantos, para a tela avisar.
 * → {eventos, semData: {ambientes, tarefas}}
 */
export function eventosDoCalendario(demandas = [], tarefas = [], { base = "limite", hoje = new Date() } = {}) {
  const deAmbientes = (demandas || []).map((d) => eventoDoAmbiente(d, base));
  const deTarefas = (tarefas || []).map((t) => eventoDaTarefa(t, base, hoje));
  return {
    eventos: [...deAmbientes, ...deTarefas].filter(Boolean),
    semData: {
      ambientes: deAmbientes.filter((e) => !e).length,
      tarefas: deTarefas.filter((e) => !e).length,
    },
  };
}
